const ERR_CODE_KEYS = ["errCode", "errorCode", "code"];

const isObjectLike = value => value !== null && typeof value === "object";

export function normalizePayload(payload) {
  if (typeof payload !== "string") return payload;

  const trimmed = payload.trim();
  if (!trimmed) return payload;

  const looksLikeJson =
    (trimmed.startsWith("{") && trimmed.endsWith("}")) ||
    (trimmed.startsWith("[") && trimmed.endsWith("]"));

  if (!looksLikeJson) return payload;

  try {
    return JSON.parse(trimmed);
  } catch (e) {
    return payload;
  }
}

export function extractErrCode(payload) {
  const normalized = normalizePayload(payload);

  if (!isObjectLike(normalized)) return null;

  for (const key of ERR_CODE_KEYS) {
    const raw = normalized[key];
    if (raw === undefined || raw === null || raw === "") continue;

    const num = Number(raw);
    return Number.isNaN(num) ? raw : num;
  }

  return null;
}
